import { Box, InputLabel, MenuItem, TextField } from '@mui/material';
import { Field, FieldProps } from 'formik';
import { Identifier } from 'modules/global/adapters/crpAPI';
import FormikSelect from 'modules/global/components/FormikSelect/FormikSelect';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { getIdentifierValue } from 'utils/IdentifierMapper';

const CompaniesSearchStep = () => {
  const { t } = useTranslation(['glossary', 'validation']);

  const identifiers = Object.keys(Identifier) as string[];

  return (
    <React.Fragment>
      <Box marginTop={2}>
        <Field name="identificationType" id="identificationType">
          {({ field, form }: FieldProps) => (
            <React.Fragment>
              <InputLabel id="identificationType">{t('identifier')}</InputLabel>
              <FormikSelect defaultValue={undefined} form={form} field={field} error={false}>
                {identifiers &&
                  identifiers.map((identifier: string, index: number) => (
                    <MenuItem
                      value={getIdentifierValue(identifier as Identifier)}
                      key={`identificationType_${index}`}
                    >
                      {identifier}
                    </MenuItem>
                  ))}
              </FormikSelect>
            </React.Fragment>
          )}
        </Field>
      </Box>

      <Box marginTop={2}>
        <Field name="identificationCode" id="identificationCode">
          {({ field }: FieldProps) => (
            <TextField
              {...field}
              variant="outlined"
              label={t('identifierValue')}
              fullWidth
              error={false}
            />
          )}
        </Field>
      </Box>
    </React.Fragment>
  );
};
export default CompaniesSearchStep;
